import { render, staticRenderFns } from "./MeetingStarterDialog.vue?vue&type=template&id=27157fc1"
import script from "./MeetingStarterDialog.vue?vue&type=script&lang=ts"
export * from "./MeetingStarterDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports